import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-exam-co-scholastic-student-setup',
  templateUrl: './exam-co-scholastic-student-setup.component.html',
  styleUrls: ['./exam-co-scholastic-student-setup.component.css']
})
export class ExamCoScholasticStudentSetupComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
  

  
  ClassDetails = {
    StudentID: 0,
    ClassID: 0,
    SectionID: 0,
    SubjectID: 0,
    ClassSectionID: "",
    TermID: 0,
}

    
StudentActivityList = [];
GetExamCoScholasticStudentSetup  () {
    this.StudentActivityList = [];
    if (this.ClassDetails.SubjectID == 0) {
        return;
    }
    this.spinnerService.show();
    this.StudentActivityList = [];
    

     this.examService.GetExamCoScholasticStudentSetup(this.ClassDetails.TermID, this.ClassDetails.ClassID, this.ClassDetails.SectionID,this.ClassDetails.SubjectID).subscribe( (data)=> {
        this.StudentActivityList = data.StudentActivityList;
       
         this.spinnerService.hide();
    });
}



SaveExamCoScholasticStudentSetup  () {
    if (this.ClassDetails.SubjectID == 0) {
        return;
    }
    
     this.examService.SaveExamCoScholasticStudentSetup(JSON.stringify(this.ClassDetails), JSON.stringify(this.StudentActivityList)).subscribe( (response)=> {
       

        this.globalHelper.CheckActionStatus(response);
        

    });

}
      


ClassSectionList:any;
GetClassSection  () {
     this.lookupService.GetLookupsList('CTClassSection', '').subscribe( (data)=> {
        this.ClassSectionList = data.LookupItems;

    });

};
SetID  () {
    this.ClassDetails.ClassID = 0;
    this.ClassDetails.TermID = 0;
    this.ClassDetails.SectionID = 0;
    this.ClassDetails.SubjectID = 0;
    if (this.ClassDetails.ClassSectionID != "") {
        var strClassSectionID = this.ClassDetails.ClassSectionID.split('-');
        this.ClassDetails.ClassID = parseInt(strClassSectionID[0]);
         this.ClassDetails.SectionID = parseInt(strClassSectionID[1]);
        this.GetTerm();
       
    }
   
}

TermList:any;
GetTerm  () {
    this.StudentActivityList = [];
    this.ClassDetails.TermID = 0;
    this.ClassDetails.SubjectID = 0;
    this.spinnerService.show();
    var ItemBo = {
        ItemId: this.ClassDetails.ClassID
    }
     this.lookupService.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.TermList = data.LookupItems;
         this.spinnerService.hide();
    });
};
StudentSubjectList:any;
GetStudentElective  () {
    this.spinnerService.show();
    this.StudentActivityList = [];            
    this.ClassDetails.SubjectID = 0;

    var ItemBO = {
        ItemId: this.ClassDetails.ClassID,               
    }
     this.lookupService.GetLookupsList('SubjectActivity', JSON.stringify(ItemBO)).subscribe( (data)=> {
        this.StudentSubjectList = data.LookupItems;
         this.spinnerService.hide();
    });
};

  ngOnInit() {
    this.GetClassSection();
  }

  AllPresent=false;
  PresentAll() {
    if (this.AllPresent) {
        for (var i = 0; i < this.StudentActivityList.length; i++) {
            this.StudentActivityList[i].IsActive = true;
            
        }
    }
    if (!this.AllPresent) {
        for (var i = 0; i < this.StudentActivityList.length; i++) {
            this.StudentActivityList[i].IsActive = false;
            
        }
    }
}

}
